export default {"src":"/_next/static/media/battery.d480fdd5.svg","height":22,"width":40,"blurWidth":0,"blurHeight":0};